define('views/modules/goal/list/goal-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/list/fetch-list',
    'views/modules/goal/list/goal-list-item',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VFetchList,
    VGoalListItem
) {

    var VGoalList = VFetchList.extend({
        item: VGoalListItem,

        getItemOptions: function(options) {
            return _.extend(options, _.pick(this.options, ['calendarDays', 'url', 'group', 'profile', 'role']));
        },
    });

    return VGoalList;

});

